<script>
import { Upload } from 'element-ui'
import * as CommonUtil from '@/utils/commonUtil'

export default {
  name: 'CargoElUpload',
  extends: Upload,
  props: {
    headers: { type: Object, default: () => { return {} } }
  },
  watch: {
    headers: {
      immediate: true,
      handler(newVal) {
        if (typeof newVal === 'object') {
          if (newVal) {
            if (!newVal.hasOwnProperty('sessionId')) {
              newVal.sessionId = this.$store.getters.userInfo.sessionId
            }
            if (!newVal.hasOwnProperty('language')) {
              if (this.$store.getters.language === 'zh') {
                newVal.language = 'zh_CN'
              } else if (this.$store.getters.language === 'en') {
                newVal.language = 'en_US'
              } else if (this.$store.getters.language === 'ja') {
                newVal.language = 'ja_JP'
              } else if (this.$store.getters.language === 'ru') {
                newVal.language = 'ru_RU'
              } else if (this.$store.getters.language === 'vi') {
                newVal.language = 'vi_VN'
              } else if (this.$store.getters.language === 'th') {
                newVal.language = 'th_TH'
              }
            }
            // 获取时区
            newVal.zone = CommonUtil.requestTimeZone()
          } else {
            throw new Error('Invalid prop: type check failed for prop "headers". Value cannot be null.')
          }
        }
      }
    }
  }
}
</script>
